import { getPurchaseInfo } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback, useEffect, useRef } from "react";

const useTrackPaymentFailure = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");

  const isEnabledRef = useRef(false);

  useEffect(() => {
    isEnabledRef.current = isWebEngageEnabled;
  }, [isWebEngageEnabled]);

  const trackPaymentFailure = useCallback((orderData) => {
    if (!isEnabledRef.current) {
      console.warn("WebEngage feature is disabled");
      return;
    }

    if (typeof window !== "undefined" && window.webengage) {
      if (orderData) {
        const eventData = {
          failure_reason: orderData?.status || "Unknown",
          ...getPurchaseInfo(orderData),
        };
        window.webengage.track("payment_failure", eventData);
      }
    } else {
      console.error("WebEngage is not defined");
    }
  }, []);

  return { trackPaymentFailure };
};

export default useTrackPaymentFailure;
